import { SxProps, Theme } from '@mui/material';

// Main container styles
export const getContainerStyles = (compact: boolean): SxProps<Theme> => ({
  width: '100%',
  py: 0,
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start', // Keep content at top
  // iPad Air portrait specific (820px width)
  '@media (min-width: 810px) and (max-width: 830px)': compact ? {
    '& > *': {
      paddingLeft: '0.4rem',
      paddingRight: '0.4rem'
    }
  } : undefined,
  // iPad Air landscape specific (1180px width)
  '@media (min-width: 1170px) and (max-width: 1190px)': compact ? {
    '& > *': {
      paddingLeft: '0.6rem',
      paddingRight: '0.6rem'
    }
  } : undefined
});

// Airport name title styles
export const getTitleStyles = (compact: boolean, hasWarning: boolean, hasError: boolean): SxProps<Theme> => ({
  color: '#fff',
  mb: (hasWarning || hasError) ? 0.15 : (compact ? 0.2 : 2),
  px: compact ? 1 : 2,
  pt: compact ? 0.5 : 0,
  fontSize: compact ? {
    xs: '0.875rem',  // 14px
    sm: '0.9rem',    // ~14.4px
    md: '0.95rem',   // ~15.2px
    lg: '1rem',      // 16px
    xl: '1.1rem'     // ~17.6px
  } : undefined,
  '@media (min-width: 1920px)': compact ? {
    fontSize: '1.15rem'  // ~18.4px
  } : undefined,
  '@media (min-width: 2560px)': compact ? {
    fontSize: '1.25rem'  // 20px
  } : undefined,
  fontWeight: compact ? 600 : undefined
});

// Warning box styles
export const getWarningBoxStyles = (compact: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 152, 0, 0.1)',
  borderLeft: '3px solid #ff9800',
  px: compact ? 0.75 : 2,
  py: compact ? 0.15 : 0.25,
  mb: compact ? 0.25 : 1,
  // iPad Air portrait specific
  '@media (min-width: 810px) and (max-width: 830px)': compact ? {
    mb: 0.1,
    py: 0.08
  } : undefined,
  // iPad Air landscape specific
  '@media (min-width: 1170px) and (max-width: 1190px)': compact ? {
    mb: 0.12,
    py: 0.1
  } : undefined
});

// Error box styles
export const getErrorBoxStyles = (compact: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'rgba(211, 47, 47, 0.1)',
  borderLeft: '3px solid #d32f2f',
  px: compact ? 0.75 : 2,
  py: compact ? 0.15 : 0.25,
  mb: compact ? 0.25 : 1,
  // iPad Air portrait specific
  '@media (min-width: 810px) and (max-width: 830px)': compact ? {
    mb: 0.1,
    py: 0.08
  } : undefined,
  // iPad Air landscape specific
  '@media (min-width: 1170px) and (max-width: 1190px)': compact ? {
    mb: 0.12,
    py: 0.1
  } : undefined
});

// Warning icon styles
export const getWarningIconStyles = (compact: boolean): SxProps<Theme> => ({
  color: '#ffb74d',
  fontSize: compact ? {
    xs: '0.875rem',
    lg: '0.95rem',
    xl: '1rem'
  } : '1rem',
  mr: 0.75
});

// Error icon styles
export const getErrorIconStyles = (compact: boolean): SxProps<Theme> => ({
  color: '#f44336',
  fontSize: compact ? {
    xs: '0.875rem',
    lg: '0.95rem',
    xl: '1rem'
  } : '1rem',
  mr: 0.75
});

// Warning text styles
export const getWarningTextStyles = (compact: boolean): SxProps<Theme> => ({
  color: '#ffb74d',
  fontSize: compact ? {
    xs: '0.7rem',
    lg: '0.75rem',
    xl: '0.8rem'
  } : '0.75rem',
  lineHeight: 1.2
});

// Error text styles
export const getErrorTextStyles = (compact: boolean): SxProps<Theme> => ({
  color: '#f44336',
  fontSize: compact ? {
    xs: '0.7rem',
    lg: '0.75rem',
    xl: '0.8rem'
  } : '0.75rem',
  lineHeight: 1.2,
  fontWeight: 500
});

// Timeline wrapper styles
export const getTimelineWrapperStyles = (compact: boolean): SxProps<Theme> => ({
  width: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  px: compact ? 0 : undefined,
  display: 'flex',
  alignItems: compact ? 'flex-start' : 'center',
  '& svg': {
    width: '100%',
    height: 'auto'
  }
});

// No data container styles
export const noDataContainerStyles: SxProps<Theme> = {
  p: 2,
  textAlign: 'center'
};

// No data title styles
export const noDataTitleStyles: SxProps<Theme> = {
  color: '#fff',
  mb: 2
};

// No data message styles
export const noDataMessageStyles: SxProps<Theme> = {
  color: '#999'
};

// No data caption styles
export const noDataCaptionStyles: SxProps<Theme> = {
  color: '#666',
  mt: 1,
  display: 'block'
};